
// Meta

var $tip = $('<div class="fast-tooltip">Blank</div>').hide().appendTo(document.body);


//
// Fast Tooltips
//

module.exports = function FastTooltipsWidget ($host, config) {

  // Dom
  var $targets = $('[data-tooltip]', $host);

  // Setup
  config.mode = config.mode ? config.mode : 'text';

  // Functions
  function moveTo (event) {
    var w = window.innerWidth;

    if (event.pageX < w/2) {
      $tip.css({
        left: event.pageX + 2,
        right: '',
        top: event.pageY + 2
      });
    } else {
      $tip.css({
        right: w - event.pageX - 2,
        left: '',
        top: event.pageY + 2
      })
    }
  }

  function displayTip (event) {
    var $this = $(this), text = $this.data('tooltip');
    if (config.mode === 'html') { $tip.html(text) } else { $tip.text(text) }
    $tip.attr('data-style', $this.data('tooltip-style') || 'normal');
    moveTo(event);
    $tip.show();
  }

  function hideTip () {
    $tip.hide();
  }

  // Listeners
  $host.on('mouseenter', '[data-tooltip]', displayTip);
  $host.on('mousemove',  '[data-tooltip]', moveTo);
  $host.on('mouseleave', '[data-tooltip]', hideTip);

}

